// Generated from Figma tokens. Do not edit directly.

export const tokens = {
  blue: {
    "1": {
      key: "{blue.1}",
      value: "#eeedf6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#eeedf6",
        key: "{blue.1}",
      },
      name: "Blue1",
      attributes: {
        category: "blue",
        type: "1",
      },
      path: ["blue", "1"],
    },
    "2": {
      key: "{blue.2}",
      value: "#e4e1ed",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#e4e1ed",
        key: "{blue.2}",
      },
      name: "Blue2",
      attributes: {
        category: "blue",
        type: "2",
      },
      path: ["blue", "2"],
    },
    "3": {
      key: "{blue.3}",
      value: "#aea7c9",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#aea7c9",
        key: "{blue.3}",
      },
      name: "Blue3",
      attributes: {
        category: "blue",
        type: "3",
      },
      path: ["blue", "3"],
    },
    "4": {
      key: "{blue.4}",
      value: "#655ab0",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#655ab0",
        key: "{blue.4}",
      },
      name: "Blue4",
      attributes: {
        category: "blue",
        type: "4",
      },
      path: ["blue", "4"],
    },
    "5": {
      key: "{blue.5}",
      value: "#4439a3",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#4439a3",
        key: "{blue.5}",
      },
      name: "Blue5",
      attributes: {
        category: "blue",
        type: "5",
      },
      path: ["blue", "5"],
    },
    "6": {
      key: "{blue.6}",
      value: "#0d058f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#0d058f",
        key: "{blue.6}",
      },
      name: "Blue6",
      attributes: {
        category: "blue",
        type: "6",
      },
      path: ["blue", "6"],
    },
    "7": {
      key: "{blue.7}",
      value: "#08047d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#08047d",
        key: "{blue.7}",
      },
      name: "Blue7",
      attributes: {
        category: "blue",
        type: "7",
      },
      path: ["blue", "7"],
    },
    "8": {
      key: "{blue.8}",
      value: "#131070",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#131070",
        key: "{blue.8}",
      },
      name: "Blue8",
      attributes: {
        category: "blue",
        type: "8",
      },
      path: ["blue", "8"],
    },
    "9": {
      key: "{blue.9}",
      value: "#07074a",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#07074a",
        key: "{blue.9}",
      },
      name: "Blue9",
      attributes: {
        category: "blue",
        type: "9",
      },
      path: ["blue", "9"],
    },
    "10": {
      key: "{blue.10}",
      value: "#010324",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#010324",
        key: "{blue.10}",
      },
      name: "Blue10",
      attributes: {
        category: "blue",
        type: "10",
      },
      path: ["blue", "10"],
    },
  },
  cyan: {
    "1": {
      key: "{cyan.1}",
      value: "#e6fffb",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#e6fffb",
        key: "{cyan.1}",
      },
      name: "Cyan1",
      attributes: {
        category: "cyan",
        type: "1",
      },
      path: ["cyan", "1"],
    },
    "2": {
      key: "{cyan.2}",
      value: "#b5f5ec",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#b5f5ec",
        key: "{cyan.2}",
      },
      name: "Cyan2",
      attributes: {
        category: "cyan",
        type: "2",
      },
      path: ["cyan", "2"],
    },
    "3": {
      key: "{cyan.3}",
      value: "#87e8de",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#87e8de",
        key: "{cyan.3}",
      },
      name: "Cyan3",
      attributes: {
        category: "cyan",
        type: "3",
      },
      path: ["cyan", "3"],
    },
    "4": {
      key: "{cyan.4}",
      value: "#5cdbd3",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#5cdbd3",
        key: "{cyan.4}",
      },
      name: "Cyan4",
      attributes: {
        category: "cyan",
        type: "4",
      },
      path: ["cyan", "4"],
    },
    "5": {
      key: "{cyan.5}",
      value: "#36cfc9",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#36cfc9",
        key: "{cyan.5}",
      },
      name: "Cyan5",
      attributes: {
        category: "cyan",
        type: "5",
      },
      path: ["cyan", "5"],
    },
    "6": {
      key: "{cyan.6}",
      value: "#13c2c2",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#13c2c2",
        key: "{cyan.6}",
      },
      name: "Cyan6",
      attributes: {
        category: "cyan",
        type: "6",
      },
      path: ["cyan", "6"],
    },
    "7": {
      key: "{cyan.7}",
      value: "#08979c",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#08979c",
        key: "{cyan.7}",
      },
      name: "Cyan7",
      attributes: {
        category: "cyan",
        type: "7",
      },
      path: ["cyan", "7"],
    },
    "8": {
      key: "{cyan.8}",
      value: "#006d75",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#006d75",
        key: "{cyan.8}",
      },
      name: "Cyan8",
      attributes: {
        category: "cyan",
        type: "8",
      },
      path: ["cyan", "8"],
    },
    "9": {
      key: "{cyan.9}",
      value: "#00474f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#00474f",
        key: "{cyan.9}",
      },
      name: "Cyan9",
      attributes: {
        category: "cyan",
        type: "9",
      },
      path: ["cyan", "9"],
    },
    "10": {
      key: "{cyan.10}",
      value: "#002329",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#002329",
        key: "{cyan.10}",
      },
      name: "Cyan10",
      attributes: {
        category: "cyan",
        type: "10",
      },
      path: ["cyan", "10"],
    },
  },
  geekblue: {
    "1": {
      key: "{geekblue.1}",
      value: "#f0f5ff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f0f5ff",
        key: "{geekblue.1}",
      },
      name: "Geekblue1",
      attributes: {
        category: "geekblue",
        type: "1",
      },
      path: ["geekblue", "1"],
    },
    "2": {
      key: "{geekblue.2}",
      value: "#d6e4ff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d6e4ff",
        key: "{geekblue.2}",
      },
      name: "Geekblue2",
      attributes: {
        category: "geekblue",
        type: "2",
      },
      path: ["geekblue", "2"],
    },
    "3": {
      key: "{geekblue.3}",
      value: "#adc6ff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#adc6ff",
        key: "{geekblue.3}",
      },
      name: "Geekblue3",
      attributes: {
        category: "geekblue",
        type: "3",
      },
      path: ["geekblue", "3"],
    },
    "4": {
      key: "{geekblue.4}",
      value: "#85a5ff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#85a5ff",
        key: "{geekblue.4}",
      },
      name: "Geekblue4",
      attributes: {
        category: "geekblue",
        type: "4",
      },
      path: ["geekblue", "4"],
    },
    "5": {
      key: "{geekblue.5}",
      value: "#597ef7",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#597ef7",
        key: "{geekblue.5}",
      },
      name: "Geekblue5",
      attributes: {
        category: "geekblue",
        type: "5",
      },
      path: ["geekblue", "5"],
    },
    "6": {
      key: "{geekblue.6}",
      value: "#2f54eb",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#2f54eb",
        key: "{geekblue.6}",
      },
      name: "Geekblue6",
      attributes: {
        category: "geekblue",
        type: "6",
      },
      path: ["geekblue", "6"],
    },
    "7": {
      key: "{geekblue.7}",
      value: "#1d39c4",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#1d39c4",
        key: "{geekblue.7}",
      },
      name: "Geekblue7",
      attributes: {
        category: "geekblue",
        type: "7",
      },
      path: ["geekblue", "7"],
    },
    "8": {
      key: "{geekblue.8}",
      value: "#10239e",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#10239e",
        key: "{geekblue.8}",
      },
      name: "Geekblue8",
      attributes: {
        category: "geekblue",
        type: "8",
      },
      path: ["geekblue", "8"],
    },
    "9": {
      key: "{geekblue.9}",
      value: "#061178",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#061178",
        key: "{geekblue.9}",
      },
      name: "Geekblue9",
      attributes: {
        category: "geekblue",
        type: "9",
      },
      path: ["geekblue", "9"],
    },
    "10": {
      key: "{geekblue.10}",
      value: "#030852",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#030852",
        key: "{geekblue.10}",
      },
      name: "Geekblue10",
      attributes: {
        category: "geekblue",
        type: "10",
      },
      path: ["geekblue", "10"],
    },
  },
  gold: {
    "1": {
      key: "{gold.1}",
      value: "#fff8d4",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff8d4",
        key: "{gold.1}",
      },
      name: "Gold1",
      attributes: {
        category: "gold",
        type: "1",
      },
      path: ["gold", "1"],
    },
    "2": {
      key: "{gold.2}",
      value: "#fff1b8",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff1b8",
        key: "{gold.2}",
      },
      name: "Gold2",
      attributes: {
        category: "gold",
        type: "2",
      },
      path: ["gold", "2"],
    },
    "3": {
      key: "{gold.3}",
      value: "#ffe58f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffe58f",
        key: "{gold.3}",
      },
      name: "Gold3",
      attributes: {
        category: "gold",
        type: "3",
      },
      path: ["gold", "3"],
    },
    "4": {
      key: "{gold.4}",
      value: "#ffd666",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffd666",
        key: "{gold.4}",
      },
      name: "Gold4",
      attributes: {
        category: "gold",
        type: "4",
      },
      path: ["gold", "4"],
    },
    "5": {
      key: "{gold.5}",
      value: "#ffc53d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffc53d",
        key: "{gold.5}",
      },
      name: "Gold5",
      attributes: {
        category: "gold",
        type: "5",
      },
      path: ["gold", "5"],
    },
    "6": {
      key: "{gold.6}",
      value: "#faad14",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#faad14",
        key: "{gold.6}",
      },
      name: "Gold6",
      attributes: {
        category: "gold",
        type: "6",
      },
      path: ["gold", "6"],
    },
    "7": {
      key: "{gold.7}",
      value: "#d48806",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d48806",
        key: "{gold.7}",
      },
      name: "Gold7",
      attributes: {
        category: "gold",
        type: "7",
      },
      path: ["gold", "7"],
    },
    "8": {
      key: "{gold.8}",
      value: "#b05800",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#b05800",
        key: "{gold.8}",
      },
      name: "Gold8",
      attributes: {
        category: "gold",
        type: "8",
      },
      path: ["gold", "8"],
    },
    "9": {
      key: "{gold.9}",
      value: "#874d00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#874d00",
        key: "{gold.9}",
      },
      name: "Gold9",
      attributes: {
        category: "gold",
        type: "9",
      },
      path: ["gold", "9"],
    },
    "10": {
      key: "{gold.10}",
      value: "#613400",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#613400",
        key: "{gold.10}",
      },
      name: "Gold10",
      attributes: {
        category: "gold",
        type: "10",
      },
      path: ["gold", "10"],
    },
  },
  green: {
    "1": {
      key: "{green.1}",
      value: "#f0ffe1",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f0ffe1",
        key: "{green.1}",
      },
      name: "Green1",
      attributes: {
        category: "green",
        type: "1",
      },
      path: ["green", "1"],
    },
    "2": {
      key: "{green.2}",
      value: "#d9f7be",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d9f7be",
        key: "{green.2}",
      },
      name: "Green2",
      attributes: {
        category: "green",
        type: "2",
      },
      path: ["green", "2"],
    },
    "3": {
      key: "{green.3}",
      value: "#b7eb8f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#b7eb8f",
        key: "{green.3}",
      },
      name: "Green3",
      attributes: {
        category: "green",
        type: "3",
      },
      path: ["green", "3"],
    },
    "4": {
      key: "{green.4}",
      value: "#95de64",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#95de64",
        key: "{green.4}",
      },
      name: "Green4",
      attributes: {
        category: "green",
        type: "4",
      },
      path: ["green", "4"],
    },
    "5": {
      key: "{green.5}",
      value: "#73d13d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#73d13d",
        key: "{green.5}",
      },
      name: "Green5",
      attributes: {
        category: "green",
        type: "5",
      },
      path: ["green", "5"],
    },
    "6": {
      key: "{green.6}",
      value: "#52c41a",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#52c41a",
        key: "{green.6}",
      },
      name: "Green6",
      attributes: {
        category: "green",
        type: "6",
      },
      path: ["green", "6"],
    },
    "7": {
      key: "{green.7}",
      value: "#389e0d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#389e0d",
        key: "{green.7}",
      },
      name: "Green7",
      attributes: {
        category: "green",
        type: "7",
      },
      path: ["green", "7"],
    },
    "8": {
      key: "{green.8}",
      value: "#237804",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#237804",
        key: "{green.8}",
      },
      name: "Green8",
      attributes: {
        category: "green",
        type: "8",
      },
      path: ["green", "8"],
    },
    "9": {
      key: "{green.9}",
      value: "#135200",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#135200",
        key: "{green.9}",
      },
      name: "Green9",
      attributes: {
        category: "green",
        type: "9",
      },
      path: ["green", "9"],
    },
    "10": {
      key: "{green.10}",
      value: "#092b00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#092b00",
        key: "{green.10}",
      },
      name: "Green10",
      attributes: {
        category: "green",
        type: "10",
      },
      path: ["green", "10"],
    },
  },
  lime: {
    "1": {
      key: "{lime.1}",
      value: "#fcffe6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fcffe6",
        key: "{lime.1}",
      },
      name: "Lime1",
      attributes: {
        category: "lime",
        type: "1",
      },
      path: ["lime", "1"],
    },
    "2": {
      key: "{lime.2}",
      value: "#f4ffb8",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f4ffb8",
        key: "{lime.2}",
      },
      name: "Lime2",
      attributes: {
        category: "lime",
        type: "2",
      },
      path: ["lime", "2"],
    },
    "3": {
      key: "{lime.3}",
      value: "#eaff8f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#eaff8f",
        key: "{lime.3}",
      },
      name: "Lime3",
      attributes: {
        category: "lime",
        type: "3",
      },
      path: ["lime", "3"],
    },
    "4": {
      key: "{lime.4}",
      value: "#d3f261",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d3f261",
        key: "{lime.4}",
      },
      name: "Lime4",
      attributes: {
        category: "lime",
        type: "4",
      },
      path: ["lime", "4"],
    },
    "5": {
      key: "{lime.5}",
      value: "#bae637",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#bae637",
        key: "{lime.5}",
      },
      name: "Lime5",
      attributes: {
        category: "lime",
        type: "5",
      },
      path: ["lime", "5"],
    },
    "6": {
      key: "{lime.6}",
      value: "#a0d911",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#a0d911",
        key: "{lime.6}",
      },
      name: "Lime6",
      attributes: {
        category: "lime",
        type: "6",
      },
      path: ["lime", "6"],
    },
    "7": {
      key: "{lime.7}",
      value: "#7cb305",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#7cb305",
        key: "{lime.7}",
      },
      name: "Lime7",
      attributes: {
        category: "lime",
        type: "7",
      },
      path: ["lime", "7"],
    },
    "8": {
      key: "{lime.8}",
      value: "#5b8c00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#5b8c00",
        key: "{lime.8}",
      },
      name: "Lime8",
      attributes: {
        category: "lime",
        type: "8",
      },
      path: ["lime", "8"],
    },
    "9": {
      key: "{lime.9}",
      value: "#3f6600",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#3f6600",
        key: "{lime.9}",
      },
      name: "Lime9",
      attributes: {
        category: "lime",
        type: "9",
      },
      path: ["lime", "9"],
    },
    "10": {
      key: "{lime.10}",
      value: "#254000",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#254000",
        key: "{lime.10}",
      },
      name: "Lime10",
      attributes: {
        category: "lime",
        type: "10",
      },
      path: ["lime", "10"],
    },
  },
  magenta: {
    "1": {
      key: "{magenta.1}",
      value: "#fff0f6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff0f6",
        key: "{magenta.1}",
      },
      name: "Magenta1",
      attributes: {
        category: "magenta",
        type: "1",
      },
      path: ["magenta", "1"],
    },
    "2": {
      key: "{magenta.2}",
      value: "#ffd6e7",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffd6e7",
        key: "{magenta.2}",
      },
      name: "Magenta2",
      attributes: {
        category: "magenta",
        type: "2",
      },
      path: ["magenta", "2"],
    },
    "3": {
      key: "{magenta.3}",
      value: "#ffadd2",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffadd2",
        key: "{magenta.3}",
      },
      name: "Magenta3",
      attributes: {
        category: "magenta",
        type: "3",
      },
      path: ["magenta", "3"],
    },
    "4": {
      key: "{magenta.4}",
      value: "#ff85c0",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ff85c0",
        key: "{magenta.4}",
      },
      name: "Magenta4",
      attributes: {
        category: "magenta",
        type: "4",
      },
      path: ["magenta", "4"],
    },
    "5": {
      key: "{magenta.5}",
      value: "#f759ab",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f759ab",
        key: "{magenta.5}",
      },
      name: "Magenta5",
      attributes: {
        category: "magenta",
        type: "5",
      },
      path: ["magenta", "5"],
    },
    "6": {
      key: "{magenta.6}",
      value: "#eb2f96",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#eb2f96",
        key: "{magenta.6}",
      },
      name: "Magenta6",
      attributes: {
        category: "magenta",
        type: "6",
      },
      path: ["magenta", "6"],
    },
    "7": {
      key: "{magenta.7}",
      value: "#c41d7f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#c41d7f",
        key: "{magenta.7}",
      },
      name: "Magenta7",
      attributes: {
        category: "magenta",
        type: "7",
      },
      path: ["magenta", "7"],
    },
    "8": {
      key: "{magenta.8}",
      value: "#9e1068",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#9e1068",
        key: "{magenta.8}",
      },
      name: "Magenta8",
      attributes: {
        category: "magenta",
        type: "8",
      },
      path: ["magenta", "8"],
    },
    "9": {
      key: "{magenta.9}",
      value: "#780650",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#780650",
        key: "{magenta.9}",
      },
      name: "Magenta9",
      attributes: {
        category: "magenta",
        type: "9",
      },
      path: ["magenta", "9"],
    },
    "10": {
      key: "{magenta.10}",
      value: "#520339",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#520339",
        key: "{magenta.10}",
      },
      name: "Magenta10",
      attributes: {
        category: "magenta",
        type: "10",
      },
      path: ["magenta", "10"],
    },
  },
  orange: {
    "1": {
      key: "{orange.1}",
      value: "#fff7e6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff7e6",
        key: "{orange.1}",
      },
      name: "Orange1",
      attributes: {
        category: "orange",
        type: "1",
      },
      path: ["orange", "1"],
    },
    "2": {
      key: "{orange.2}",
      value: "#ffe7ba",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffe7ba",
        key: "{orange.2}",
      },
      name: "Orange2",
      attributes: {
        category: "orange",
        type: "2",
      },
      path: ["orange", "2"],
    },
    "3": {
      key: "{orange.3}",
      value: "#ffd591",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffd591",
        key: "{orange.3}",
      },
      name: "Orange3",
      attributes: {
        category: "orange",
        type: "3",
      },
      path: ["orange", "3"],
    },
    "4": {
      key: "{orange.4}",
      value: "#ffc069",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffc069",
        key: "{orange.4}",
      },
      name: "Orange4",
      attributes: {
        category: "orange",
        type: "4",
      },
      path: ["orange", "4"],
    },
    "5": {
      key: "{orange.5}",
      value: "#ffa940",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffa940",
        key: "{orange.5}",
      },
      name: "Orange5",
      attributes: {
        category: "orange",
        type: "5",
      },
      path: ["orange", "5"],
    },
    "6": {
      key: "{orange.6}",
      value: "#fa8c16",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fa8c16",
        key: "{orange.6}",
      },
      name: "Orange6",
      attributes: {
        category: "orange",
        type: "6",
      },
      path: ["orange", "6"],
    },
    "7": {
      key: "{orange.7}",
      value: "#d46b08",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d46b08",
        key: "{orange.7}",
      },
      name: "Orange7",
      attributes: {
        category: "orange",
        type: "7",
      },
      path: ["orange", "7"],
    },
    "8": {
      key: "{orange.8}",
      value: "#ad4e00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ad4e00",
        key: "{orange.8}",
      },
      name: "Orange8",
      attributes: {
        category: "orange",
        type: "8",
      },
      path: ["orange", "8"],
    },
    "9": {
      key: "{orange.9}",
      value: "#873800",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#873800",
        key: "{orange.9}",
      },
      name: "Orange9",
      attributes: {
        category: "orange",
        type: "9",
      },
      path: ["orange", "9"],
    },
    "10": {
      key: "{orange.10}",
      value: "#612500",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#612500",
        key: "{orange.10}",
      },
      name: "Orange10",
      attributes: {
        category: "orange",
        type: "10",
      },
      path: ["orange", "10"],
    },
  },
  colorText: {
    key: "{colorText}",
    value: "rgba(0, 0, 0, 0.88)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.88)",
      key: "{colorText}",
    },
    name: "ColorText",
    attributes: {
      category: "colorText",
    },
    path: ["colorText"],
  },
  colorTextSecondary: {
    key: "{colorTextSecondary}",
    value: "rgba(0, 0, 0, 0.65)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.65)",
      key: "{colorTextSecondary}",
    },
    name: "ColorTextSecondary",
    attributes: {
      category: "colorTextSecondary",
    },
    path: ["colorTextSecondary"],
  },
  colorTextTertiary: {
    key: "{colorTextTertiary}",
    value: "rgba(0, 0, 0, 0.7)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.7)",
      key: "{colorTextTertiary}",
    },
    name: "ColorTextTertiary",
    attributes: {
      category: "colorTextTertiary",
    },
    path: ["colorTextTertiary"],
  },
  colorTextQuaternary: {
    key: "{colorTextQuaternary}",
    value: "rgba(0, 0, 0, 0.22)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.22)",
      key: "{colorTextQuaternary}",
    },
    name: "ColorTextQuaternary",
    attributes: {
      category: "colorTextQuaternary",
    },
    path: ["colorTextQuaternary"],
  },
  colorTextLightSolid: {
    key: "{colorTextLightSolid}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorTextLightSolid}",
    },
    name: "ColorTextLightSolid",
    attributes: {
      category: "colorTextLightSolid",
    },
    path: ["colorTextLightSolid"],
  },
  colorTextHeading: {
    key: "{colorTextHeading}",
    value: "rgba(0, 0, 0, 0.88)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.88)",
      key: "{colorTextHeading}",
    },
    name: "ColorTextHeading",
    attributes: {
      category: "colorTextHeading",
    },
    path: ["colorTextHeading"],
  },
  colorTextLabel: {
    key: "{colorTextLabel}",
    value: "rgba(0, 0, 0, 0.65)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.65)",
      key: "{colorTextLabel}",
    },
    name: "ColorTextLabel",
    attributes: {
      category: "colorTextLabel",
    },
    path: ["colorTextLabel"],
  },
  colorTextDescription: {
    key: "{colorTextDescription}",
    value: "rgba(0, 0, 0, 0.7)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.7)",
      key: "{colorTextDescription}",
    },
    name: "ColorTextDescription",
    attributes: {
      category: "colorTextDescription",
    },
    path: ["colorTextDescription"],
  },
  colorTextDisabled: {
    key: "{colorTextDisabled}",
    value: "rgba(0, 0, 0, 0.22)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.22)",
      key: "{colorTextDisabled}",
    },
    name: "ColorTextDisabled",
    attributes: {
      category: "colorTextDisabled",
    },
    path: ["colorTextDisabled"],
  },
  purple: {
    "1": {
      key: "{purple.1}",
      value: "#f9f0ff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f9f0ff",
        key: "{purple.1}",
      },
      name: "Purple1",
      attributes: {
        category: "purple",
        type: "1",
      },
      path: ["purple", "1"],
    },
    "2": {
      key: "{purple.2}",
      value: "#efdbff",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#efdbff",
        key: "{purple.2}",
      },
      name: "Purple2",
      attributes: {
        category: "purple",
        type: "2",
      },
      path: ["purple", "2"],
    },
    "3": {
      key: "{purple.3}",
      value: "#d3adf7",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d3adf7",
        key: "{purple.3}",
      },
      name: "Purple3",
      attributes: {
        category: "purple",
        type: "3",
      },
      path: ["purple", "3"],
    },
    "4": {
      key: "{purple.4}",
      value: "#b37feb",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#b37feb",
        key: "{purple.4}",
      },
      name: "Purple4",
      attributes: {
        category: "purple",
        type: "4",
      },
      path: ["purple", "4"],
    },
    "5": {
      key: "{purple.5}",
      value: "#9254de",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#9254de",
        key: "{purple.5}",
      },
      name: "Purple5",
      attributes: {
        category: "purple",
        type: "5",
      },
      path: ["purple", "5"],
    },
    "6": {
      key: "{purple.6}",
      value: "#722ed1",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#722ed1",
        key: "{purple.6}",
      },
      name: "Purple6",
      attributes: {
        category: "purple",
        type: "6",
      },
      path: ["purple", "6"],
    },
    "7": {
      key: "{purple.7}",
      value: "#531dab",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#531dab",
        key: "{purple.7}",
      },
      name: "Purple7",
      attributes: {
        category: "purple",
        type: "7",
      },
      path: ["purple", "7"],
    },
    "8": {
      key: "{purple.8}",
      value: "#391085",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#391085",
        key: "{purple.8}",
      },
      name: "Purple8",
      attributes: {
        category: "purple",
        type: "8",
      },
      path: ["purple", "8"],
    },
    "9": {
      key: "{purple.9}",
      value: "#22075e",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#22075e",
        key: "{purple.9}",
      },
      name: "Purple9",
      attributes: {
        category: "purple",
        type: "9",
      },
      path: ["purple", "9"],
    },
    "10": {
      key: "{purple.10}",
      value: "#120338",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#120338",
        key: "{purple.10}",
      },
      name: "Purple10",
      attributes: {
        category: "purple",
        type: "10",
      },
      path: ["purple", "10"],
    },
  },
  colorTextPlaceholder: {
    key: "{colorTextPlaceholder}",
    value: "rgba(0, 0, 0, 0.22)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.22)",
      key: "{colorTextPlaceholder}",
    },
    name: "ColorTextPlaceholder",
    attributes: {
      category: "colorTextPlaceholder",
    },
    path: ["colorTextPlaceholder"],
  },
  colorIcon: {
    key: "{colorIcon}",
    value: "rgba(0, 0, 0, 0.65)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.65)",
      key: "{colorIcon}",
    },
    name: "ColorIcon",
    attributes: {
      category: "colorIcon",
    },
    path: ["colorIcon"],
  },
  colorIconHover: {
    key: "{colorIconHover}",
    value: "rgba(0, 0, 0, 0.88)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.88)",
      key: "{colorIconHover}",
    },
    name: "ColorIconHover",
    attributes: {
      category: "colorIconHover",
    },
    path: ["colorIconHover"],
  },
  colorBgContainer: {
    key: "{colorBgContainer}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorBgContainer}",
    },
    name: "ColorBgContainer",
    attributes: {
      category: "colorBgContainer",
    },
    path: ["colorBgContainer"],
  },
  colorBgElevated: {
    key: "{colorBgElevated}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorBgElevated}",
    },
    name: "ColorBgElevated",
    attributes: {
      category: "colorBgElevated",
    },
    path: ["colorBgElevated"],
  },
  colorBgLayout: {
    key: "{colorBgLayout}",
    value: "#f2ece6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f2ece6",
      key: "{colorBgLayout}",
    },
    name: "ColorBgLayout",
    attributes: {
      category: "colorBgLayout",
    },
    path: ["colorBgLayout"],
  },
  colorBgMask: {
    key: "{colorBgMask}",
    value: "rgba(0, 0, 0, 0.45)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.45)",
      key: "{colorBgMask}",
    },
    name: "ColorBgMask",
    attributes: {
      category: "colorBgMask",
    },
    path: ["colorBgMask"],
  },
  colorBgSpotlight: {
    key: "{colorBgSpotlight}",
    value: "rgba(0, 0, 0, 0.85)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.85)",
      key: "{colorBgSpotlight}",
    },
    name: "ColorBgSpotlight",
    attributes: {
      category: "colorBgSpotlight",
    },
    path: ["colorBgSpotlight"],
  },
  colorBorder: {
    key: "{colorBorder}",
    value: "#cdcaca",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#cdcaca",
      key: "{colorBorder}",
    },
    name: "ColorBorder",
    attributes: {
      category: "colorBorder",
    },
    path: ["colorBorder"],
  },
  colorBorderSecondary: {
    key: "{colorBorderSecondary}",
    value: "#ebebeb",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ebebeb",
      key: "{colorBorderSecondary}",
    },
    name: "ColorBorderSecondary",
    attributes: {
      category: "colorBorderSecondary",
    },
    path: ["colorBorderSecondary"],
  },
  red: {
    "1": {
      key: "{red.1}",
      value: "#fff1f0",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff1f0",
        key: "{red.1}",
      },
      name: "Red1",
      attributes: {
        category: "red",
        type: "1",
      },
      path: ["red", "1"],
    },
    "2": {
      key: "{red.2}",
      value: "#ffccc7",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffccc7",
        key: "{red.2}",
      },
      name: "Red2",
      attributes: {
        category: "red",
        type: "2",
      },
      path: ["red", "2"],
    },
    "3": {
      key: "{red.3}",
      value: "#ffa39e",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffa39e",
        key: "{red.3}",
      },
      name: "Red3",
      attributes: {
        category: "red",
        type: "3",
      },
      path: ["red", "3"],
    },
    "4": {
      key: "{red.4}",
      value: "#ff7875",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ff7875",
        key: "{red.4}",
      },
      name: "Red4",
      attributes: {
        category: "red",
        type: "4",
      },
      path: ["red", "4"],
    },
    "5": {
      key: "{red.5}",
      value: "#ff4d4f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ff4d4f",
        key: "{red.5}",
      },
      name: "Red5",
      attributes: {
        category: "red",
        type: "5",
      },
      path: ["red", "5"],
    },
    "6": {
      key: "{red.6}",
      value: "#f5222d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f5222d",
        key: "{red.6}",
      },
      name: "Red6",
      attributes: {
        category: "red",
        type: "6",
      },
      path: ["red", "6"],
    },
    "7": {
      key: "{red.7}",
      value: "#cf1322",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#cf1322",
        key: "{red.7}",
      },
      name: "Red7",
      attributes: {
        category: "red",
        type: "7",
      },
      path: ["red", "7"],
    },
    "8": {
      key: "{red.8}",
      value: "#a8071a",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#a8071a",
        key: "{red.8}",
      },
      name: "Red8",
      attributes: {
        category: "red",
        type: "8",
      },
      path: ["red", "8"],
    },
    "9": {
      key: "{red.9}",
      value: "#820014",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#820014",
        key: "{red.9}",
      },
      name: "Red9",
      attributes: {
        category: "red",
        type: "9",
      },
      path: ["red", "9"],
    },
    "10": {
      key: "{red.10}",
      value: "#5c0011",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#5c0011",
        key: "{red.10}",
      },
      name: "Red10",
      attributes: {
        category: "red",
        type: "10",
      },
      path: ["red", "10"],
    },
  },
  colorFill: {
    key: "{colorFill}",
    value: "#f7f4f1",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f7f4f1",
      key: "{colorFill}",
    },
    name: "ColorFill",
    attributes: {
      category: "colorFill",
    },
    path: ["colorFill"],
  },
  colorFillSecondary: {
    key: "{colorFillSecondary}",
    value: "#f6f4ff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f6f4ff",
      key: "{colorFillSecondary}",
    },
    name: "ColorFillSecondary",
    attributes: {
      category: "colorFillSecondary",
    },
    path: ["colorFillSecondary"],
  },
  colorFillTertiary: {
    key: "{colorFillTertiary}",
    value: "rgba(0, 0, 0, 0.04)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.04)",
      key: "{colorFillTertiary}",
    },
    name: "ColorFillTertiary",
    attributes: {
      category: "colorFillTertiary",
    },
    path: ["colorFillTertiary"],
  },
  colorFillQuaternary: {
    key: "{colorFillQuaternary}",
    value: "rgba(0, 0, 0, 0.02)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.02)",
      key: "{colorFillQuaternary}",
    },
    name: "ColorFillQuaternary",
    attributes: {
      category: "colorFillQuaternary",
    },
    path: ["colorFillQuaternary"],
  },
  colorWhite: {
    key: "{colorWhite}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorWhite}",
    },
    name: "ColorWhite",
    attributes: {
      category: "colorWhite",
    },
    path: ["colorWhite"],
  },
  colorBgBase: {
    key: "{colorBgBase}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorBgBase}",
    },
    name: "ColorBgBase",
    attributes: {
      category: "colorBgBase",
    },
    path: ["colorBgBase"],
  },
  colorTextBase: {
    key: "{colorTextBase}",
    value: "#000000",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#000000",
      key: "{colorTextBase}",
    },
    name: "ColorTextBase",
    attributes: {
      category: "colorTextBase",
    },
    path: ["colorTextBase"],
  },
  colorBgContainerDisabled: {
    key: "{colorBgContainerDisabled}",
    value: "rgba(0, 0, 0, 0.04)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.04)",
      key: "{colorBgContainerDisabled}",
    },
    name: "ColorBgContainerDisabled",
    attributes: {
      category: "colorBgContainerDisabled",
    },
    path: ["colorBgContainerDisabled"],
  },
  colorBgTextActive: {
    key: "{colorBgTextActive}",
    value: "#f7f4f1",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f7f4f1",
      key: "{colorBgTextActive}",
    },
    name: "ColorBgTextActive",
    attributes: {
      category: "colorBgTextActive",
    },
    path: ["colorBgTextActive"],
  },
  colorBgTextHover: {
    key: "{colorBgTextHover}",
    value: "#f6f4ff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f6f4ff",
      key: "{colorBgTextHover}",
    },
    name: "ColorBgTextHover",
    attributes: {
      category: "colorBgTextHover",
    },
    path: ["colorBgTextHover"],
  },
  volcano: {
    "1": {
      key: "{volcano.1}",
      value: "#fff2e8",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff2e8",
        key: "{volcano.1}",
      },
      name: "Volcano1",
      attributes: {
        category: "volcano",
        type: "1",
      },
      path: ["volcano", "1"],
    },
    "2": {
      key: "{volcano.2}",
      value: "#ffd8bf",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffd8bf",
        key: "{volcano.2}",
      },
      name: "Volcano2",
      attributes: {
        category: "volcano",
        type: "2",
      },
      path: ["volcano", "2"],
    },
    "3": {
      key: "{volcano.3}",
      value: "#ffbb96",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffbb96",
        key: "{volcano.3}",
      },
      name: "Volcano3",
      attributes: {
        category: "volcano",
        type: "3",
      },
      path: ["volcano", "3"],
    },
    "4": {
      key: "{volcano.4}",
      value: "#ff9c6e",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ff9c6e",
        key: "{volcano.4}",
      },
      name: "Volcano4",
      attributes: {
        category: "volcano",
        type: "4",
      },
      path: ["volcano", "4"],
    },
    "5": {
      key: "{volcano.5}",
      value: "#ff7a45",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ff7a45",
        key: "{volcano.5}",
      },
      name: "Volcano5",
      attributes: {
        category: "volcano",
        type: "5",
      },
      path: ["volcano", "5"],
    },
    "6": {
      key: "{volcano.6}",
      value: "#fa541c",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fa541c",
        key: "{volcano.6}",
      },
      name: "Volcano6",
      attributes: {
        category: "volcano",
        type: "6",
      },
      path: ["volcano", "6"],
    },
    "7": {
      key: "{volcano.7}",
      value: "#d4380d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d4380d",
        key: "{volcano.7}",
      },
      name: "Volcano7",
      attributes: {
        category: "volcano",
        type: "7",
      },
      path: ["volcano", "7"],
    },
    "8": {
      key: "{volcano.8}",
      value: "#ad2102",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ad2102",
        key: "{volcano.8}",
      },
      name: "Volcano8",
      attributes: {
        category: "volcano",
        type: "8",
      },
      path: ["volcano", "8"],
    },
    "9": {
      key: "{volcano.9}",
      value: "#871400",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#871400",
        key: "{volcano.9}",
      },
      name: "Volcano9",
      attributes: {
        category: "volcano",
        type: "9",
      },
      path: ["volcano", "9"],
    },
    "10": {
      key: "{volcano.10}",
      value: "#610b00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#610b00",
        key: "{volcano.10}",
      },
      name: "Volcano10",
      attributes: {
        category: "volcano",
        type: "10",
      },
      path: ["volcano", "10"],
    },
  },
  colorBorderBg: {
    key: "{colorBorderBg}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorBorderBg}",
    },
    name: "ColorBorderBg",
    attributes: {
      category: "colorBorderBg",
    },
    path: ["colorBorderBg"],
  },
  colorFillContent: {
    key: "{colorFillContent}",
    value: "#f6f4ff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f6f4ff",
      key: "{colorFillContent}",
    },
    name: "ColorFillContent",
    attributes: {
      category: "colorFillContent",
    },
    path: ["colorFillContent"],
  },
  colorFillContentHover: {
    key: "{colorFillContentHover}",
    value: "#f7f4f1",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f7f4f1",
      key: "{colorFillContentHover}",
    },
    name: "ColorFillContentHover",
    attributes: {
      category: "colorFillContentHover",
    },
    path: ["colorFillContentHover"],
  },
  colorFillAlter: {
    key: "{colorFillAlter}",
    value: "rgba(0, 0, 0, 0.02)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.02)",
      key: "{colorFillAlter}",
    },
    name: "ColorFillAlter",
    attributes: {
      category: "colorFillAlter",
    },
    path: ["colorFillAlter"],
  },
  transparent: {
    key: "{transparent}",
    value: "rgba(0, 0, 0, 0)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0)",
      key: "{transparent}",
    },
    name: "Transparent",
    attributes: {
      category: "transparent",
    },
    path: ["transparent"],
  },
  colorSplit: {
    key: "{colorSplit}",
    value: "rgba(0, 0, 0, 0.06)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.06)",
      key: "{colorSplit}",
    },
    name: "ColorSplit",
    attributes: {
      category: "colorSplit",
    },
    path: ["colorSplit"],
  },
  yellow: {
    "1": {
      key: "{yellow.1}",
      value: "#feffe6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#feffe6",
        key: "{yellow.1}",
      },
      name: "Yellow1",
      attributes: {
        category: "yellow",
        type: "1",
      },
      path: ["yellow", "1"],
    },
    "2": {
      key: "{yellow.2}",
      value: "#ffffb8",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffffb8",
        key: "{yellow.2}",
      },
      name: "Yellow2",
      attributes: {
        category: "yellow",
        type: "2",
      },
      path: ["yellow", "2"],
    },
    "3": {
      key: "{yellow.3}",
      value: "#fffb8f",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fffb8f",
        key: "{yellow.3}",
      },
      name: "Yellow3",
      attributes: {
        category: "yellow",
        type: "3",
      },
      path: ["yellow", "3"],
    },
    "4": {
      key: "{yellow.4}",
      value: "#fff566",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fff566",
        key: "{yellow.4}",
      },
      name: "Yellow4",
      attributes: {
        category: "yellow",
        type: "4",
      },
      path: ["yellow", "4"],
    },
    "5": {
      key: "{yellow.5}",
      value: "#ffec3d",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ffec3d",
        key: "{yellow.5}",
      },
      name: "Yellow5",
      attributes: {
        category: "yellow",
        type: "5",
      },
      path: ["yellow", "5"],
    },
    "6": {
      key: "{yellow.6}",
      value: "#fadb14",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#fadb14",
        key: "{yellow.6}",
      },
      name: "Yellow6",
      attributes: {
        category: "yellow",
        type: "6",
      },
      path: ["yellow", "6"],
    },
    "7": {
      key: "{yellow.7}",
      value: "#d4b106",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#d4b106",
        key: "{yellow.7}",
      },
      name: "Yellow7",
      attributes: {
        category: "yellow",
        type: "7",
      },
      path: ["yellow", "7"],
    },
    "8": {
      key: "{yellow.8}",
      value: "#ad8b00",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#ad8b00",
        key: "{yellow.8}",
      },
      name: "Yellow8",
      attributes: {
        category: "yellow",
        type: "8",
      },
      path: ["yellow", "8"],
    },
    "9": {
      key: "{yellow.9}",
      value: "#876800",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#876800",
        key: "{yellow.9}",
      },
      name: "Yellow9",
      attributes: {
        category: "yellow",
        type: "9",
      },
      path: ["yellow", "9"],
    },
    "10": {
      key: "{yellow.10}",
      value: "#614700",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#614700",
        key: "{yellow.10}",
      },
      name: "Yellow10",
      attributes: {
        category: "yellow",
        type: "10",
      },
      path: ["yellow", "10"],
    },
  },
  colorPrimary: {
    key: "{colorPrimary}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{colorPrimary}",
    },
    name: "ColorPrimary",
    attributes: {
      category: "colorPrimary",
    },
    path: ["colorPrimary"],
  },
  colorSuccess: {
    key: "{colorSuccess}",
    value: "#52c41a",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#52c41a",
      key: "{colorSuccess}",
    },
    name: "ColorSuccess",
    attributes: {
      category: "colorSuccess",
    },
    path: ["colorSuccess"],
  },
  colorWarning: {
    key: "{colorWarning}",
    value: "#faad14",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#faad14",
      key: "{colorWarning}",
    },
    name: "ColorWarning",
    attributes: {
      category: "colorWarning",
    },
    path: ["colorWarning"],
  },
  colorInfo: {
    key: "{colorInfo}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{colorInfo}",
    },
    name: "ColorInfo",
    attributes: {
      category: "colorInfo",
    },
    path: ["colorInfo"],
  },
  colorError: {
    key: "{colorError}",
    value: "#ff4d4f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ff4d4f",
      key: "{colorError}",
    },
    name: "ColorError",
    attributes: {
      category: "colorError",
    },
    path: ["colorError"],
  },
  colorLink: {
    key: "{colorLink}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{colorLink}",
    },
    name: "ColorLink",
    attributes: {
      category: "colorLink",
    },
    path: ["colorLink"],
  },
  colorErrorBg: {
    key: "{colorErrorBg}",
    value: "#fff2f0",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#fff2f0",
      key: "{colorErrorBg}",
    },
    name: "ColorErrorBg",
    attributes: {
      category: "colorErrorBg",
    },
    path: ["colorErrorBg"],
  },
  colorErrorBgHover: {
    key: "{colorErrorBgHover}",
    value: "#fff1f0",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#fff1f0",
      key: "{colorErrorBgHover}",
    },
    name: "ColorErrorBgHover",
    attributes: {
      category: "colorErrorBgHover",
    },
    path: ["colorErrorBgHover"],
  },
  colorErrorBorder: {
    key: "{colorErrorBorder}",
    value: "#ffccc7",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffccc7",
      key: "{colorErrorBorder}",
    },
    name: "ColorErrorBorder",
    attributes: {
      category: "colorErrorBorder",
    },
    path: ["colorErrorBorder"],
  },
  colorErrorBorderHover: {
    key: "{colorErrorBorderHover}",
    value: "#ffa39e",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffa39e",
      key: "{colorErrorBorderHover}",
    },
    name: "ColorErrorBorderHover",
    attributes: {
      category: "colorErrorBorderHover",
    },
    path: ["colorErrorBorderHover"],
  },
  colorErrorHover: {
    key: "{colorErrorHover}",
    value: "#ff7875",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ff7875",
      key: "{colorErrorHover}",
    },
    name: "ColorErrorHover",
    attributes: {
      category: "colorErrorHover",
    },
    path: ["colorErrorHover"],
  },
  colorErrorActive: {
    key: "{colorErrorActive}",
    value: "#d9363e",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#d9363e",
      key: "{colorErrorActive}",
    },
    name: "ColorErrorActive",
    attributes: {
      category: "colorErrorActive",
    },
    path: ["colorErrorActive"],
  },
  colorErrorTextHover: {
    key: "{colorErrorTextHover}",
    value: "#ff7875",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ff7875",
      key: "{colorErrorTextHover}",
    },
    name: "ColorErrorTextHover",
    attributes: {
      category: "colorErrorTextHover",
    },
    path: ["colorErrorTextHover"],
  },
  colorErrorText: {
    key: "{colorErrorText}",
    value: "#ff4d4f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ff4d4f",
      key: "{colorErrorText}",
    },
    name: "ColorErrorText",
    attributes: {
      category: "colorErrorText",
    },
    path: ["colorErrorText"],
  },
  colorErrorTextActive: {
    key: "{colorErrorTextActive}",
    value: "#cf1322",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#cf1322",
      key: "{colorErrorTextActive}",
    },
    name: "ColorErrorTextActive",
    attributes: {
      category: "colorErrorTextActive",
    },
    path: ["colorErrorTextActive"],
  },
  colorLinkHover: {
    key: "{colorLinkHover}",
    value: "#4439a3",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#4439a3",
      key: "{colorLinkHover}",
    },
    name: "ColorLinkHover",
    attributes: {
      category: "colorLinkHover",
    },
    path: ["colorLinkHover"],
  },
  colorInfoBg: {
    key: "{colorInfoBg}",
    value: "#eeedf6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#eeedf6",
      key: "{colorInfoBg}",
    },
    name: "ColorInfoBg",
    attributes: {
      category: "colorInfoBg",
    },
    path: ["colorInfoBg"],
  },
  colorInfoBgHover: {
    key: "{colorInfoBgHover}",
    value: "#eeedf6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#eeedf6",
      key: "{colorInfoBgHover}",
    },
    name: "ColorInfoBgHover",
    attributes: {
      category: "colorInfoBgHover",
    },
    path: ["colorInfoBgHover"],
  },
  colorInfoBorder: {
    key: "{colorInfoBorder}",
    value: "#e4e1ed",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#e4e1ed",
      key: "{colorInfoBorder}",
    },
    name: "ColorInfoBorder",
    attributes: {
      category: "colorInfoBorder",
    },
    path: ["colorInfoBorder"],
  },
  colorInfoBorderHover: {
    key: "{colorInfoBorderHover}",
    value: "#655ab0",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#655ab0",
      key: "{colorInfoBorderHover}",
    },
    name: "ColorInfoBorderHover",
    attributes: {
      category: "colorInfoBorderHover",
    },
    path: ["colorInfoBorderHover"],
  },
  colorInfoHover: {
    key: "{colorInfoHover}",
    value: "#4439a3",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#4439a3",
      key: "{colorInfoHover}",
    },
    name: "ColorInfoHover",
    attributes: {
      category: "colorInfoHover",
    },
    path: ["colorInfoHover"],
  },
  colorInfoActive: {
    key: "{colorInfoActive}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{colorInfoActive}",
    },
    name: "ColorInfoActive",
    attributes: {
      category: "colorInfoActive",
    },
    path: ["colorInfoActive"],
  },
  colorInfoTextHover: {
    key: "{colorInfoTextHover}",
    value: "#4439a3",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#4439a3",
      key: "{colorInfoTextHover}",
    },
    name: "ColorInfoTextHover",
    attributes: {
      category: "colorInfoTextHover",
    },
    path: ["colorInfoTextHover"],
  },
  colorInfoText: {
    key: "{colorInfoText}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{colorInfoText}",
    },
    name: "ColorInfoText",
    attributes: {
      category: "colorInfoText",
    },
    path: ["colorInfoText"],
  },
  colorInfoTextActive: {
    key: "{colorInfoTextActive}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{colorInfoTextActive}",
    },
    name: "ColorInfoTextActive",
    attributes: {
      category: "colorInfoTextActive",
    },
    path: ["colorInfoTextActive"],
  },
  colorLinkActive: {
    key: "{colorLinkActive}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{colorLinkActive}",
    },
    name: "ColorLinkActive",
    attributes: {
      category: "colorLinkActive",
    },
    path: ["colorLinkActive"],
  },
  colorPrimaryBg: {
    key: "{colorPrimaryBg}",
    value: "#eeedf6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#eeedf6",
      key: "{colorPrimaryBg}",
    },
    name: "ColorPrimaryBg",
    attributes: {
      category: "colorPrimaryBg",
    },
    path: ["colorPrimaryBg"],
  },
  colorPrimaryBgHover: {
    key: "{colorPrimaryBgHover}",
    value: "#eeedf6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#eeedf6",
      key: "{colorPrimaryBgHover}",
    },
    name: "ColorPrimaryBgHover",
    attributes: {
      category: "colorPrimaryBgHover",
    },
    path: ["colorPrimaryBgHover"],
  },
  colorPrimaryBorder: {
    key: "{colorPrimaryBorder}",
    value: "#e4e1ed",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#e4e1ed",
      key: "{colorPrimaryBorder}",
    },
    name: "ColorPrimaryBorder",
    attributes: {
      category: "colorPrimaryBorder",
    },
    path: ["colorPrimaryBorder"],
  },
  colorPrimaryBorderHover: {
    key: "{colorPrimaryBorderHover}",
    value: "#655ab0",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#655ab0",
      key: "{colorPrimaryBorderHover}",
    },
    name: "ColorPrimaryBorderHover",
    attributes: {
      category: "colorPrimaryBorderHover",
    },
    path: ["colorPrimaryBorderHover"],
  },
  colorPrimaryHover: {
    key: "{colorPrimaryHover}",
    value: "#4439a3",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#4439a3",
      key: "{colorPrimaryHover}",
    },
    name: "ColorPrimaryHover",
    attributes: {
      category: "colorPrimaryHover",
    },
    path: ["colorPrimaryHover"],
  },
  colorPrimaryActive: {
    key: "{colorPrimaryActive}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{colorPrimaryActive}",
    },
    name: "ColorPrimaryActive",
    attributes: {
      category: "colorPrimaryActive",
    },
    path: ["colorPrimaryActive"],
  },
  colorPrimaryTextHover: {
    key: "{colorPrimaryTextHover}",
    value: "#4439a3",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#4439a3",
      key: "{colorPrimaryTextHover}",
    },
    name: "ColorPrimaryTextHover",
    attributes: {
      category: "colorPrimaryTextHover",
    },
    path: ["colorPrimaryTextHover"],
  },
  colorPrimaryText: {
    key: "{colorPrimaryText}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{colorPrimaryText}",
    },
    name: "ColorPrimaryText",
    attributes: {
      category: "colorPrimaryText",
    },
    path: ["colorPrimaryText"],
  },
  colorPrimaryTextActive: {
    key: "{colorPrimaryTextActive}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{colorPrimaryTextActive}",
    },
    name: "ColorPrimaryTextActive",
    attributes: {
      category: "colorPrimaryTextActive",
    },
    path: ["colorPrimaryTextActive"],
  },
  colorSuccessBg: {
    key: "{colorSuccessBg}",
    value: "#f0ffe1",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f0ffe1",
      key: "{colorSuccessBg}",
    },
    name: "ColorSuccessBg",
    attributes: {
      category: "colorSuccessBg",
    },
    path: ["colorSuccessBg"],
  },
  colorSuccessBgHover: {
    key: "{colorSuccessBgHover}",
    value: "#d9f7be",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#d9f7be",
      key: "{colorSuccessBgHover}",
    },
    name: "ColorSuccessBgHover",
    attributes: {
      category: "colorSuccessBgHover",
    },
    path: ["colorSuccessBgHover"],
  },
  colorSuccessBorder: {
    key: "{colorSuccessBorder}",
    value: "#b7eb8f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#b7eb8f",
      key: "{colorSuccessBorder}",
    },
    name: "ColorSuccessBorder",
    attributes: {
      category: "colorSuccessBorder",
    },
    path: ["colorSuccessBorder"],
  },
  colorSuccessBorderHover: {
    key: "{colorSuccessBorderHover}",
    value: "#95de64",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#95de64",
      key: "{colorSuccessBorderHover}",
    },
    name: "ColorSuccessBorderHover",
    attributes: {
      category: "colorSuccessBorderHover",
    },
    path: ["colorSuccessBorderHover"],
  },
  colorSuccessHover: {
    key: "{colorSuccessHover}",
    value: "#95de64",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#95de64",
      key: "{colorSuccessHover}",
    },
    name: "ColorSuccessHover",
    attributes: {
      category: "colorSuccessHover",
    },
    path: ["colorSuccessHover"],
  },
  colorSuccessActive: {
    key: "{colorSuccessActive}",
    value: "#389e0d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#389e0d",
      key: "{colorSuccessActive}",
    },
    name: "ColorSuccessActive",
    attributes: {
      category: "colorSuccessActive",
    },
    path: ["colorSuccessActive"],
  },
  colorSuccessTextHover: {
    key: "{colorSuccessTextHover}",
    value: "#73d13d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#73d13d",
      key: "{colorSuccessTextHover}",
    },
    name: "ColorSuccessTextHover",
    attributes: {
      category: "colorSuccessTextHover",
    },
    path: ["colorSuccessTextHover"],
  },
  colorSuccessText: {
    key: "{colorSuccessText}",
    value: "#52c41a",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#52c41a",
      key: "{colorSuccessText}",
    },
    name: "ColorSuccessText",
    attributes: {
      category: "colorSuccessText",
    },
    path: ["colorSuccessText"],
  },
  colorSuccessTextActive: {
    key: "{colorSuccessTextActive}",
    value: "#135200",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#135200",
      key: "{colorSuccessTextActive}",
    },
    name: "ColorSuccessTextActive",
    attributes: {
      category: "colorSuccessTextActive",
    },
    path: ["colorSuccessTextActive"],
  },
  colorWarningBg: {
    key: "{colorWarningBg}",
    value: "#fff8d4",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#fff8d4",
      key: "{colorWarningBg}",
    },
    name: "ColorWarningBg",
    attributes: {
      category: "colorWarningBg",
    },
    path: ["colorWarningBg"],
  },
  colorWarningBgHover: {
    key: "{colorWarningBgHover}",
    value: "#fff1b8",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#fff1b8",
      key: "{colorWarningBgHover}",
    },
    name: "ColorWarningBgHover",
    attributes: {
      category: "colorWarningBgHover",
    },
    path: ["colorWarningBgHover"],
  },
  colorWarningBorder: {
    key: "{colorWarningBorder}",
    value: "#ffe58f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffe58f",
      key: "{colorWarningBorder}",
    },
    name: "ColorWarningBorder",
    attributes: {
      category: "colorWarningBorder",
    },
    path: ["colorWarningBorder"],
  },
  colorWarningBorderHover: {
    key: "{colorWarningBorderHover}",
    value: "#ffd666",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffd666",
      key: "{colorWarningBorderHover}",
    },
    name: "ColorWarningBorderHover",
    attributes: {
      category: "colorWarningBorderHover",
    },
    path: ["colorWarningBorderHover"],
  },
  colorWarningHover: {
    key: "{colorWarningHover}",
    value: "#ffd666",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffd666",
      key: "{colorWarningHover}",
    },
    name: "ColorWarningHover",
    attributes: {
      category: "colorWarningHover",
    },
    path: ["colorWarningHover"],
  },
  colorWarningActive: {
    key: "{colorWarningActive}",
    value: "#d48806",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#d48806",
      key: "{colorWarningActive}",
    },
    name: "ColorWarningActive",
    attributes: {
      category: "colorWarningActive",
    },
    path: ["colorWarningActive"],
  },
  colorWarningTextHover: {
    key: "{colorWarningTextHover}",
    value: "#ffc53d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffc53d",
      key: "{colorWarningTextHover}",
    },
    name: "ColorWarningTextHover",
    attributes: {
      category: "colorWarningTextHover",
    },
    path: ["colorWarningTextHover"],
  },
  colorWarningText: {
    key: "{colorWarningText}",
    value: "#b05800",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#b05800",
      key: "{colorWarningText}",
    },
    name: "ColorWarningText",
    attributes: {
      category: "colorWarningText",
    },
    path: ["colorWarningText"],
  },
  colorWarningTextActive: {
    key: "{colorWarningTextActive}",
    value: "#b05800",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#b05800",
      key: "{colorWarningTextActive}",
    },
    name: "ColorWarningTextActive",
    attributes: {
      category: "colorWarningTextActive",
    },
    path: ["colorWarningTextActive"],
  },
  colorErrorOutline: {
    key: "{colorErrorOutline}",
    value: "rgba(255, 38, 6, 0.06)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(255, 38, 6, 0.06)",
      key: "{colorErrorOutline}",
    },
    name: "ColorErrorOutline",
    attributes: {
      category: "colorErrorOutline",
    },
    path: ["colorErrorOutline"],
  },
  colorWarningOutline: {
    key: "{colorWarningOutline}",
    value: "rgba(255, 215, 5, 0.1)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(255, 215, 5, 0.1)",
      key: "{colorWarningOutline}",
    },
    name: "ColorWarningOutline",
    attributes: {
      category: "colorWarningOutline",
    },
    path: ["colorWarningOutline"],
  },
  controlItemBgActive: {
    key: "{controlItemBgActive}",
    value: "#eeedf6",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#eeedf6",
      key: "{controlItemBgActive}",
    },
    name: "ControlItemBgActive",
    attributes: {
      category: "controlItemBgActive",
    },
    path: ["controlItemBgActive"],
  },
  controlItemBgActiveDisabled: {
    key: "{controlItemBgActiveDisabled}",
    value: "#f7f4f1",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f7f4f1",
      key: "{controlItemBgActiveDisabled}",
    },
    name: "ControlItemBgActiveDisabled",
    attributes: {
      category: "controlItemBgActiveDisabled",
    },
    path: ["controlItemBgActiveDisabled"],
  },
  controlItemBgActiveHover: {
    key: "{controlItemBgActiveHover}",
    value: "#e4e1ed",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#e4e1ed",
      key: "{controlItemBgActiveHover}",
    },
    name: "ControlItemBgActiveHover",
    attributes: {
      category: "controlItemBgActiveHover",
    },
    path: ["controlItemBgActiveHover"],
  },
  controlItemBgHover: {
    key: "{controlItemBgHover}",
    value: "rgba(0, 0, 0, 0.04)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.04)",
      key: "{controlItemBgHover}",
    },
    name: "ControlItemBgHover",
    attributes: {
      category: "controlItemBgHover",
    },
    path: ["controlItemBgHover"],
  },
  controlOutline: {
    key: "{controlOutline}",
    value: "#08047d",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#08047d",
      key: "{controlOutline}",
    },
    name: "ControlOutline",
    attributes: {
      category: "controlOutline",
    },
    path: ["controlOutline"],
  },
  controlTmpOutline: {
    key: "{controlTmpOutline}",
    value: "rgba(0, 0, 0, 0.02)",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "rgba(0, 0, 0, 0.02)",
      key: "{controlTmpOutline}",
    },
    name: "ControlTmpOutline",
    attributes: {
      category: "controlTmpOutline",
    },
    path: ["controlTmpOutline"],
  },
  borderRadius: {
    key: "{borderRadius}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{borderRadius}",
    },
    name: "BorderRadius",
    attributes: {
      category: "borderRadius",
    },
    path: ["borderRadius"],
  },
  borderRadiusLG: {
    key: "{borderRadiusLG}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{borderRadiusLG}",
    },
    name: "BorderRadiusLg",
    attributes: {
      category: "borderRadiusLG",
    },
    path: ["borderRadiusLG"],
  },
  borderRadiusSM: {
    key: "{borderRadiusSM}",
    value: 2,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 2,
      key: "{borderRadiusSM}",
    },
    name: "BorderRadiusSm",
    attributes: {
      category: "borderRadiusSM",
    },
    path: ["borderRadiusSM"],
  },
  borderRadiusXS: {
    key: "{borderRadiusXS}",
    value: 0,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 0,
      key: "{borderRadiusXS}",
    },
    name: "BorderRadiusXs",
    attributes: {
      category: "borderRadiusXS",
    },
    path: ["borderRadiusXS"],
  },
  sizeStep: {
    key: "{sizeStep}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{sizeStep}",
    },
    name: "SizeStep",
    attributes: {
      category: "sizeStep",
    },
    path: ["sizeStep"],
  },
  sizeUnit: {
    key: "{sizeUnit}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{sizeUnit}",
    },
    name: "SizeUnit",
    attributes: {
      category: "sizeUnit",
    },
    path: ["sizeUnit"],
  },
  controlInteractiveSize: {
    key: "{controlInteractiveSize}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{controlInteractiveSize}",
    },
    name: "ControlInteractiveSize",
    attributes: {
      category: "controlInteractiveSize",
    },
    path: ["controlInteractiveSize"],
  },
  size: {
    key: "{size}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{size}",
    },
    name: "Size",
    attributes: {
      category: "size",
    },
    path: ["size"],
  },
  sizeLG: {
    key: "{sizeLG}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{sizeLG}",
    },
    name: "SizeLg",
    attributes: {
      category: "sizeLG",
    },
    path: ["sizeLG"],
  },
  sizeMD: {
    key: "{sizeMD}",
    value: 20,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 20,
      key: "{sizeMD}",
    },
    name: "SizeMd",
    attributes: {
      category: "sizeMD",
    },
    path: ["sizeMD"],
  },
  sizeMS: {
    key: "{sizeMS}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{sizeMS}",
    },
    name: "SizeMs",
    attributes: {
      category: "sizeMS",
    },
    path: ["sizeMS"],
  },
  sizeSM: {
    key: "{sizeSM}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{sizeSM}",
    },
    name: "SizeSm",
    attributes: {
      category: "sizeSM",
    },
    path: ["sizeSM"],
  },
  sizeXL: {
    key: "{sizeXL}",
    value: 32,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 32,
      key: "{sizeXL}",
    },
    name: "SizeXl",
    attributes: {
      category: "sizeXL",
    },
    path: ["sizeXL"],
  },
  sizeXS: {
    key: "{sizeXS}",
    value: 8,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 8,
      key: "{sizeXS}",
    },
    name: "SizeXs",
    attributes: {
      category: "sizeXS",
    },
    path: ["sizeXS"],
  },
  sizeXXL: {
    key: "{sizeXXL}",
    value: 48,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 48,
      key: "{sizeXXL}",
    },
    name: "SizeXxl",
    attributes: {
      category: "sizeXXL",
    },
    path: ["sizeXXL"],
  },
  controlHeight: {
    key: "{controlHeight}",
    value: 32,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 32,
      key: "{controlHeight}",
    },
    name: "ControlHeight",
    attributes: {
      category: "controlHeight",
    },
    path: ["controlHeight"],
  },
  sizeXXS: {
    key: "{sizeXXS}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{sizeXXS}",
    },
    name: "SizeXxs",
    attributes: {
      category: "sizeXXS",
    },
    path: ["sizeXXS"],
  },
  controlHeightLG: {
    key: "{controlHeightLG}",
    value: 40,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 40,
      key: "{controlHeightLG}",
    },
    name: "ControlHeightLg",
    attributes: {
      category: "controlHeightLG",
    },
    path: ["controlHeightLG"],
  },
  controlHeightSM: {
    key: "{controlHeightSM}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{controlHeightSM}",
    },
    name: "ControlHeightSm",
    attributes: {
      category: "controlHeightSM",
    },
    path: ["controlHeightSM"],
  },
  controlHeightXS: {
    key: "{controlHeightXS}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{controlHeightXS}",
    },
    name: "ControlHeightXs",
    attributes: {
      category: "controlHeightXS",
    },
    path: ["controlHeightXS"],
  },
  lineWidth: {
    key: "{lineWidth}",
    value: 1,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1,
      key: "{lineWidth}",
    },
    name: "LineWidth",
    attributes: {
      category: "lineWidth",
    },
    path: ["lineWidth"],
  },
  lineWidthBold: {
    key: "{lineWidthBold}",
    value: 2,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 2,
      key: "{lineWidthBold}",
    },
    name: "LineWidthBold",
    attributes: {
      category: "lineWidthBold",
    },
    path: ["lineWidthBold"],
  },
  lineWidthFocus: {
    key: "{lineWidthFocus}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{lineWidthFocus}",
    },
    name: "LineWidthFocus",
    attributes: {
      category: "lineWidthFocus",
    },
    path: ["lineWidthFocus"],
  },
  controlOutlineWidth: {
    key: "{controlOutlineWidth}",
    value: 2,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 2,
      key: "{controlOutlineWidth}",
    },
    name: "ControlOutlineWidth",
    attributes: {
      category: "controlOutlineWidth",
    },
    path: ["controlOutlineWidth"],
  },
  screenLG: {
    key: "{screenLG}",
    value: 992,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 992,
      key: "{screenLG}",
    },
    name: "ScreenLg",
    attributes: {
      category: "screenLG",
    },
    path: ["screenLG"],
  },
  screenLGMax: {
    key: "{screenLGMax}",
    value: 1199,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1199,
      key: "{screenLGMax}",
    },
    name: "ScreenLgMax",
    attributes: {
      category: "screenLGMax",
    },
    path: ["screenLGMax"],
  },
  screenLGMin: {
    key: "{screenLGMin}",
    value: 992,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 992,
      key: "{screenLGMin}",
    },
    name: "ScreenLgMin",
    attributes: {
      category: "screenLGMin",
    },
    path: ["screenLGMin"],
  },
  screenMD: {
    key: "{screenMD}",
    value: 768,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 768,
      key: "{screenMD}",
    },
    name: "ScreenMd",
    attributes: {
      category: "screenMD",
    },
    path: ["screenMD"],
  },
  screenMDMax: {
    key: "{screenMDMax}",
    value: 991,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 991,
      key: "{screenMDMax}",
    },
    name: "ScreenMdMax",
    attributes: {
      category: "screenMDMax",
    },
    path: ["screenMDMax"],
  },
  screenMDMin: {
    key: "{screenMDMin}",
    value: 768,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 768,
      key: "{screenMDMin}",
    },
    name: "ScreenMdMin",
    attributes: {
      category: "screenMDMin",
    },
    path: ["screenMDMin"],
  },
  screenSM: {
    key: "{screenSM}",
    value: 576,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 576,
      key: "{screenSM}",
    },
    name: "ScreenSm",
    attributes: {
      category: "screenSM",
    },
    path: ["screenSM"],
  },
  screenSMMax: {
    key: "{screenSMMax}",
    value: 767,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 767,
      key: "{screenSMMax}",
    },
    name: "ScreenSmMax",
    attributes: {
      category: "screenSMMax",
    },
    path: ["screenSMMax"],
  },
  screenSMMin: {
    key: "{screenSMMin}",
    value: 576,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 576,
      key: "{screenSMMin}",
    },
    name: "ScreenSmMin",
    attributes: {
      category: "screenSMMin",
    },
    path: ["screenSMMin"],
  },
  screenXL: {
    key: "{screenXL}",
    value: 1200,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1200,
      key: "{screenXL}",
    },
    name: "ScreenXl",
    attributes: {
      category: "screenXL",
    },
    path: ["screenXL"],
  },
  screenXLMax: {
    key: "{screenXLMax}",
    value: 1599,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1599,
      key: "{screenXLMax}",
    },
    name: "ScreenXlMax",
    attributes: {
      category: "screenXLMax",
    },
    path: ["screenXLMax"],
  },
  screenXLMin: {
    key: "{screenXLMin}",
    value: 1200,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1200,
      key: "{screenXLMin}",
    },
    name: "ScreenXlMin",
    attributes: {
      category: "screenXLMin",
    },
    path: ["screenXLMin"],
  },
  screenXS: {
    key: "{screenXS}",
    value: 480,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 480,
      key: "{screenXS}",
    },
    name: "ScreenXs",
    attributes: {
      category: "screenXS",
    },
    path: ["screenXS"],
  },
  screenXSMax: {
    key: "{screenXSMax}",
    value: 575,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 575,
      key: "{screenXSMax}",
    },
    name: "ScreenXsMax",
    attributes: {
      category: "screenXSMax",
    },
    path: ["screenXSMax"],
  },
  screenXSMin: {
    key: "{screenXSMin}",
    value: 480,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 480,
      key: "{screenXSMin}",
    },
    name: "ScreenXsMin",
    attributes: {
      category: "screenXSMin",
    },
    path: ["screenXSMin"],
  },
  screenXXL: {
    key: "{screenXXL}",
    value: 1600,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1600,
      key: "{screenXXL}",
    },
    name: "ScreenXxl",
    attributes: {
      category: "screenXXL",
    },
    path: ["screenXXL"],
  },
  screenXXLMin: {
    key: "{screenXXLMin}",
    value: 1600,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1600,
      key: "{screenXXLMin}",
    },
    name: "ScreenXxlMin",
    attributes: {
      category: "screenXXLMin",
    },
    path: ["screenXXLMin"],
  },
  sizePopupArrow: {
    key: "{sizePopupArrow}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{sizePopupArrow}",
    },
    name: "SizePopupArrow",
    attributes: {
      category: "sizePopupArrow",
    },
    path: ["sizePopupArrow"],
  },
  margin: {
    key: "{margin}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{margin}",
    },
    name: "Margin",
    attributes: {
      category: "margin",
    },
    path: ["margin"],
  },
  marginLG: {
    key: "{marginLG}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{marginLG}",
    },
    name: "MarginLg",
    attributes: {
      category: "marginLG",
    },
    path: ["marginLG"],
  },
  marginMD: {
    key: "{marginMD}",
    value: 20,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 20,
      key: "{marginMD}",
    },
    name: "MarginMd",
    attributes: {
      category: "marginMD",
    },
    path: ["marginMD"],
  },
  marginSM: {
    key: "{marginSM}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{marginSM}",
    },
    name: "MarginSm",
    attributes: {
      category: "marginSM",
    },
    path: ["marginSM"],
  },
  marginXL: {
    key: "{marginXL}",
    value: 32,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 32,
      key: "{marginXL}",
    },
    name: "MarginXl",
    attributes: {
      category: "marginXL",
    },
    path: ["marginXL"],
  },
  marginXS: {
    key: "{marginXS}",
    value: 8,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 8,
      key: "{marginXS}",
    },
    name: "MarginXs",
    attributes: {
      category: "marginXS",
    },
    path: ["marginXS"],
  },
  marginXXL: {
    key: "{marginXXL}",
    value: 48,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 48,
      key: "{marginXXL}",
    },
    name: "MarginXxl",
    attributes: {
      category: "marginXXL",
    },
    path: ["marginXXL"],
  },
  marginXXS: {
    key: "{marginXXS}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{marginXXS}",
    },
    name: "MarginXxs",
    attributes: {
      category: "marginXXS",
    },
    path: ["marginXXS"],
  },
  padding: {
    key: "{padding}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{padding}",
    },
    name: "Padding",
    attributes: {
      category: "padding",
    },
    path: ["padding"],
  },
  paddingLG: {
    key: "{paddingLG}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{paddingLG}",
    },
    name: "PaddingLg",
    attributes: {
      category: "paddingLG",
    },
    path: ["paddingLG"],
  },
  paddingMD: {
    key: "{paddingMD}",
    value: 20,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 20,
      key: "{paddingMD}",
    },
    name: "PaddingMd",
    attributes: {
      category: "paddingMD",
    },
    path: ["paddingMD"],
  },
  paddingSM: {
    key: "{paddingSM}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{paddingSM}",
    },
    name: "PaddingSm",
    attributes: {
      category: "paddingSM",
    },
    path: ["paddingSM"],
  },
  paddingXL: {
    key: "{paddingXL}",
    value: 32,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 32,
      key: "{paddingXL}",
    },
    name: "PaddingXl",
    attributes: {
      category: "paddingXL",
    },
    path: ["paddingXL"],
  },
  paddingXS: {
    key: "{paddingXS}",
    value: 8,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 8,
      key: "{paddingXS}",
    },
    name: "PaddingXs",
    attributes: {
      category: "paddingXS",
    },
    path: ["paddingXS"],
  },
  paddingXXS: {
    key: "{paddingXXS}",
    value: 4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 4,
      key: "{paddingXXS}",
    },
    name: "PaddingXxs",
    attributes: {
      category: "paddingXXS",
    },
    path: ["paddingXXS"],
  },
  paddingContentHorizontal: {
    key: "{paddingContentHorizontal}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{paddingContentHorizontal}",
    },
    name: "PaddingContentHorizontal",
    attributes: {
      category: "paddingContentHorizontal",
    },
    path: ["paddingContentHorizontal"],
  },
  paddingContentHorizontalLG: {
    key: "{paddingContentHorizontalLG}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{paddingContentHorizontalLG}",
    },
    name: "PaddingContentHorizontalLg",
    attributes: {
      category: "paddingContentHorizontalLG",
    },
    path: ["paddingContentHorizontalLG"],
  },
  paddingContentHorizontalSM: {
    key: "{paddingContentHorizontalSM}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{paddingContentHorizontalSM}",
    },
    name: "PaddingContentHorizontalSm",
    attributes: {
      category: "paddingContentHorizontalSM",
    },
    path: ["paddingContentHorizontalSM"],
  },
  paddingContentVertical: {
    key: "{paddingContentVertical}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{paddingContentVertical}",
    },
    name: "PaddingContentVertical",
    attributes: {
      category: "paddingContentVertical",
    },
    path: ["paddingContentVertical"],
  },
  paddingContentVerticalLG: {
    key: "{paddingContentVerticalLG}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{paddingContentVerticalLG}",
    },
    name: "PaddingContentVerticalLg",
    attributes: {
      category: "paddingContentVerticalLG",
    },
    path: ["paddingContentVerticalLG"],
  },
  paddingContentVerticalSM: {
    key: "{paddingContentVerticalSM}",
    value: 8,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 8,
      key: "{paddingContentVerticalSM}",
    },
    name: "PaddingContentVerticalSm",
    attributes: {
      category: "paddingContentVerticalSM",
    },
    path: ["paddingContentVerticalSM"],
  },
  controlPaddingHorizontal: {
    key: "{controlPaddingHorizontal}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{controlPaddingHorizontal}",
    },
    name: "ControlPaddingHorizontal",
    attributes: {
      category: "controlPaddingHorizontal",
    },
    path: ["controlPaddingHorizontal"],
  },
  controlPaddingHorizontalSM: {
    key: "{controlPaddingHorizontalSM}",
    value: 8,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 8,
      key: "{controlPaddingHorizontalSM}",
    },
    name: "ControlPaddingHorizontalSm",
    attributes: {
      category: "controlPaddingHorizontalSM",
    },
    path: ["controlPaddingHorizontalSM"],
  },
  fontFamily: {
    key: "{fontFamily}",
    value: "space grotesk",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "space grotesk",
      key: "{fontFamily}",
    },
    name: "FontFamily",
    attributes: {
      category: "fontFamily",
    },
    path: ["fontFamily"],
  },
  fontFamilyCode: {
    key: "{fontFamilyCode}",
    value: "SPace grotesk",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "SPace grotesk",
      key: "{fontFamilyCode}",
    },
    name: "FontFamilyCode",
    attributes: {
      category: "fontFamilyCode",
    },
    path: ["fontFamilyCode"],
  },
  fontSize: {
    key: "{fontSize}",
    value: 14,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 14,
      key: "{fontSize}",
    },
    name: "FontSize",
    attributes: {
      category: "fontSize",
    },
    path: ["fontSize"],
  },
  fontSizeLG: {
    key: "{fontSizeLG}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{fontSizeLG}",
    },
    name: "FontSizeLg",
    attributes: {
      category: "fontSizeLG",
    },
    path: ["fontSizeLG"],
  },
  fontSizeSM: {
    key: "{fontSizeSM}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{fontSizeSM}",
    },
    name: "FontSizeSm",
    attributes: {
      category: "fontSizeSM",
    },
    path: ["fontSizeSM"],
  },
  fontSizeXL: {
    key: "{fontSizeXL}",
    value: 20,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 20,
      key: "{fontSizeXL}",
    },
    name: "FontSizeXl",
    attributes: {
      category: "fontSizeXL",
    },
    path: ["fontSizeXL"],
  },
  fontSizeHeading1: {
    key: "{fontSizeHeading1}",
    value: 38,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 38,
      key: "{fontSizeHeading1}",
    },
    name: "FontSizeHeading1",
    attributes: {
      category: "fontSizeHeading1",
    },
    path: ["fontSizeHeading1"],
  },
  fontSizeHeading2: {
    key: "{fontSizeHeading2}",
    value: 30,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 30,
      key: "{fontSizeHeading2}",
    },
    name: "FontSizeHeading2",
    attributes: {
      category: "fontSizeHeading2",
    },
    path: ["fontSizeHeading2"],
  },
  fontSizeHeading3: {
    key: "{fontSizeHeading3}",
    value: 24,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 24,
      key: "{fontSizeHeading3}",
    },
    name: "FontSizeHeading3",
    attributes: {
      category: "fontSizeHeading3",
    },
    path: ["fontSizeHeading3"],
  },
  fontSizeHeading4: {
    key: "{fontSizeHeading4}",
    value: 20,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 20,
      key: "{fontSizeHeading4}",
    },
    name: "FontSizeHeading4",
    attributes: {
      category: "fontSizeHeading4",
    },
    path: ["fontSizeHeading4"],
  },
  fontSizeHeading5: {
    key: "{fontSizeHeading5}",
    value: 16,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 16,
      key: "{fontSizeHeading5}",
    },
    name: "FontSizeHeading5",
    attributes: {
      category: "fontSizeHeading5",
    },
    path: ["fontSizeHeading5"],
  },
  lineHeight: {
    key: "{lineHeight}",
    value: 1.5714285714285714,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.5714285714285714,
      key: "{lineHeight}",
    },
    name: "LineHeight",
    attributes: {
      category: "lineHeight",
    },
    path: ["lineHeight"],
  },
  lineHeightHeading1: {
    key: "{lineHeightHeading1}",
    value: 1.2105263157894737,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.2105263157894737,
      key: "{lineHeightHeading1}",
    },
    name: "LineHeightHeading1",
    attributes: {
      category: "lineHeightHeading1",
    },
    path: ["lineHeightHeading1"],
  },
  lineHeightHeading2: {
    key: "{lineHeightHeading2}",
    value: 1.2666666666666666,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.2666666666666666,
      key: "{lineHeightHeading2}",
    },
    name: "LineHeightHeading2",
    attributes: {
      category: "lineHeightHeading2",
    },
    path: ["lineHeightHeading2"],
  },
  lineHeightHeading3: {
    key: "{lineHeightHeading3}",
    value: 1.3333333333333333,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.3333333333333333,
      key: "{lineHeightHeading3}",
    },
    name: "LineHeightHeading3",
    attributes: {
      category: "lineHeightHeading3",
    },
    path: ["lineHeightHeading3"],
  },
  lineHeightHeading4: {
    key: "{lineHeightHeading4}",
    value: 1.4,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.4,
      key: "{lineHeightHeading4}",
    },
    name: "LineHeightHeading4",
    attributes: {
      category: "lineHeightHeading4",
    },
    path: ["lineHeightHeading4"],
  },
  lineHeightHeading5: {
    key: "{lineHeightHeading5}",
    value: 1.5,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.5,
      key: "{lineHeightHeading5}",
    },
    name: "LineHeightHeading5",
    attributes: {
      category: "lineHeightHeading5",
    },
    path: ["lineHeightHeading5"],
  },
  lineHeightLG: {
    key: "{lineHeightLG}",
    value: 1.5,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.5,
      key: "{lineHeightLG}",
    },
    name: "LineHeightLg",
    attributes: {
      category: "lineHeightLG",
    },
    path: ["lineHeightLG"],
  },
  lineHeightSM: {
    key: "{lineHeightSM}",
    value: 1.6666666666666667,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 1.6666666666666667,
      key: "{lineHeightSM}",
    },
    name: "LineHeightSm",
    attributes: {
      category: "lineHeightSM",
    },
    path: ["lineHeightSM"],
  },
  fontSizeIcon: {
    key: "{fontSizeIcon}",
    value: 12,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 12,
      key: "{fontSizeIcon}",
    },
    name: "FontSizeIcon",
    attributes: {
      category: "fontSizeIcon",
    },
    path: ["fontSizeIcon"],
  },
  fontWeightStrong: {
    key: "{fontWeightStrong}",
    value: 600,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 600,
      key: "{fontWeightStrong}",
    },
    name: "FontWeightStrong",
    attributes: {
      category: "fontWeightStrong",
    },
    path: ["fontWeightStrong"],
  },
  colorFillAlterSolid: {
    key: "{colorFillAlterSolid}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{colorFillAlterSolid}",
    },
    name: "ColorFillAlterSolid",
    attributes: {
      category: "colorFillAlterSolid",
    },
    path: ["colorFillAlterSolid"],
  },
  fontWeightNormal: {
    key: "{fontWeightNormal}",
    value: 400,
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: 400,
      key: "{fontWeightNormal}",
    },
    name: "FontWeightNormal",
    attributes: {
      category: "fontWeightNormal",
    },
    path: ["fontWeightNormal"],
  },
  colorFilledHandleBg: {
    key: "{colorFilledHandleBg}",
    value: "#f0f0f0",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f0f0f0",
      key: "{colorFilledHandleBg}",
    },
    name: "ColorFilledHandleBg",
    attributes: {
      category: "colorFilledHandleBg",
    },
    path: ["colorFilledHandleBg"],
  },
  "brand Primary Indigo": {
    key: "{brand Primary Indigo}",
    value: "#0d058f",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#0d058f",
      key: "{brand Primary Indigo}",
    },
    name: "BrandPrimaryIndigo",
    attributes: {
      category: "brand Primary Indigo",
    },
    path: ["brand Primary Indigo"],
  },
  "brand Core Light Blue": {
    key: "{brand Core Light Blue}",
    value: "#285df4",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#285df4",
      key: "{brand Core Light Blue}",
    },
    name: "BrandCoreLightBlue",
    attributes: {
      category: "brand Core Light Blue",
    },
    path: ["brand Core Light Blue"],
  },
  color: {
    key: "{color}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{color}",
    },
    name: "Color",
    attributes: {
      category: "color",
    },
    path: ["color"],
  },
  "color 2": {
    key: "{color 2}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{color 2}",
    },
    name: "Color2",
    attributes: {
      category: "color 2",
    },
    path: ["color 2"],
  },
  offwhite: {
    "1": {
      key: "{offwhite.1}",
      value: "#f6f2ef",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f6f2ef",
        key: "{offwhite.1}",
      },
      name: "Offwhite1",
      attributes: {
        category: "offwhite",
        type: "1",
      },
      path: ["offwhite", "1"],
    },
    "2": {
      key: "{offwhite.2}",
      value: "#e0d4c7",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#e0d4c7",
        key: "{offwhite.2}",
      },
      name: "Offwhite2",
      attributes: {
        category: "offwhite",
        type: "2",
      },
      path: ["offwhite", "2"],
    },
    "3": {
      key: "{offwhite.3}",
      value: "#f2ece6",
      filePath: "src/design-system/config/figmaExport.sd.json",
      isSource: true,
      original: {
        value: "#f2ece6",
        key: "{offwhite.3}",
      },
      name: "Offwhite3",
      attributes: {
        category: "offwhite",
        type: "3",
      },
      path: ["offwhite", "3"],
    },
  },
  "color 3": {
    key: "{color 3}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{color 3}",
    },
    name: "Color3",
    attributes: {
      category: "color 3",
    },
    path: ["color 3"],
  },
  default: {
    key: "{default}",
    value: "#1a202c",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#1a202c",
      key: "{default}",
    },
    name: "Default",
    attributes: {
      category: "default",
    },
    path: ["default"],
  },
  muted: {
    key: "{muted}",
    value: "#f7fafc",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#f7fafc",
      key: "{muted}",
    },
    name: "Muted",
    attributes: {
      category: "muted",
    },
    path: ["muted"],
  },
  subtle: {
    key: "{subtle}",
    value: "#edf2f7",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#edf2f7",
      key: "{subtle}",
    },
    name: "Subtle",
    attributes: {
      category: "subtle",
    },
    path: ["subtle"],
  },
  onAccent: {
    key: "{onAccent}",
    value: "#ffffff",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#ffffff",
      key: "{onAccent}",
    },
    name: "OnAccent",
    attributes: {
      category: "onAccent",
    },
    path: ["onAccent"],
  },
  bg: {
    key: "{bg}",
    value: "#c3dafe",
    filePath: "src/design-system/config/figmaExport.sd.json",
    isSource: true,
    original: {
      value: "#c3dafe",
      key: "{bg}",
    },
    name: "Bg",
    attributes: {
      category: "bg",
    },
    path: ["bg"],
  },
} as const;
